(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orkidea-clientes"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('okc-clientes')) return;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    class OkcClientes extends HTMLElement {
      connectedCallback() {
        if (!this._ready) this.setup();
        this.layout();
      }

      disconnectedCallback() {
        if (this.ro) this.ro.disconnect();
        if (this.io) this.io.disconnect();
      }

      setup() {
        this._ready = true;
        this.rows = Array.prototype.slice.call(this.querySelectorAll('[data-okc-row]'));

        this.ro = new ResizeObserver(this.layout.bind(this));
        this.ro.observe(this);

        // Fuera de pantalla no animamos. Al acercarse, cargamos todas las fotos de una vez:
        // si no, las que entran a la fila desde el costado aparecen vacías y "saltan" al cargar.
        this.io = new IntersectionObserver(function (entries) {
          var near = entries[0].isIntersecting;
          this.classList.toggle('is-paused', !near);
          if (near && !this._loaded) {
            this._loaded = true;
            this.querySelectorAll('img[loading="lazy"]').forEach(function (im) { im.loading = 'eager'; });
          }
        }.bind(this), { rootMargin: '300px 0px' });
        this.io.observe(this);

        // En el editor: al seleccionar una foto, la fila se detiene para poder verla
        document.addEventListener('shopify:block:select', function (e) {
          if (this.contains(e.target)) this.classList.add('is-paused');
        }.bind(this));
        document.addEventListener('shopify:block:deselect', function (e) {
          if (this.contains(e.target)) this.classList.remove('is-paused');
        }.bind(this));
      }

      // Repite el grupo de fotos de cada fila hasta cubrir el ancho, y calcula distancia y duración.
      // Las copias ya creadas se conservan (rehacerlas recarga sus fotos y se nota un parpadeo).
      layout() {
        var speed = Number(this.dataset.speed) || 30;
        var running = !reduce.matches;
        this.rows.forEach(function (row, i) {
          var track = row.querySelector('[data-okc-track]');
          var set = track.querySelector('[data-okc-set]');
          var clones = track.querySelectorAll('[data-okc-clone]');
          if (!running) {
            clones.forEach(function (c) { c.remove(); });
            return;
          }

          var w = set.getBoundingClientRect().width;
          if (!w) return;
          var need = Math.ceil(row.clientWidth / w) + 1;
          for (var c = clones.length; c < need; c++) {
            var clone = set.cloneNode(true);
            clone.setAttribute('data-okc-clone', '');
            clone.setAttribute('aria-hidden', 'true');
            clone.querySelectorAll('[data-shopify-editor-block]').forEach(function (el) {
              el.removeAttribute('data-shopify-editor-block');
            });
            track.append(clone);
          }

          // Solo se actualiza si cambió el ancho: cambiar la duración hace saltar el recorrido
          var shift = w.toFixed(2) + 'px';
          if (track.style.getPropertyValue('--okc-shift') !== shift) {
            track.style.setProperty('--okc-shift', shift);
            // Cada fila va a un ritmo un poco distinto para que se vea más natural
            track.style.setProperty('--okc-dur', ((w / speed) * (1 + i * 0.18)).toFixed(2) + 's');
          }
        });
        this.classList.toggle('is-running', running);
      }
    }

    customElements.define('okc-clientes', OkcClientes);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orkidea-dedicatoria"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('okd-dedicatoria')) return;

    var esc = function (s) {
      return String(s).replace(/[&<>"]/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
      });
    };
    // "Te obsequio…" → "te obsequio…" cuando el nombre abre la frase ("Lucía, te obsequio…")
    var lowerFirst = function (s) {
      return s.replace(/^([¡¿"“]?)(\p{Lu})(?!\p{Lu})/u, function (m, p, c) { return p + c.toLowerCase(); });
    };

    class OkdDedicatoria extends HTMLElement {
      connectedCallback() {
        if (!this._ready) this.setup();
        document.body.append(this.lightbox, this.toast);
        window.addEventListener('keydown', this.onKey);
        this.render();
      }

      disconnectedCallback() {
        this.lightbox.remove();
        this.toast.remove();
        window.removeEventListener('keydown', this.onKey);
      }

      setup() {
        this._ready = true;
        var q = this.querySelector.bind(this);
        this.fTo = q('[data-okd-to]');
        this.fFrom = q('[data-okd-from]');
        this.fMsg = q('[data-okd-text]');
        this.note = q('[data-okd-note]');
        this.lightbox = q('[data-okd-lightbox]');
        this.toast = q('[data-okd-toast]');
        this.chips = Array.prototype.slice.call(this.querySelectorAll('[data-okd-chip]'));

        var render = this.render.bind(this);
        [this.fTo, this.fFrom, this.fMsg].forEach(function (el) { el.addEventListener('input', render); });

        this.chips.forEach(function (chip) {
          chip.addEventListener('click', function () {
            this.fMsg.value = chip.textContent.trim();
            this.render();
          }.bind(this));
        }.bind(this));

        this.note.addEventListener('click', this.openCard.bind(this));
        this.lightbox.addEventListener('click', this.closeCard.bind(this));
        this.onKey = function (e) {
          if (e.key === 'Escape' && this.lightbox.classList.contains('is-open')) this.closeCard();
        }.bind(this);

        this.addEventListener('click', function (e) {
          var btn = e.target.closest('[data-okd-add]');
          if (btn && !btn.disabled) this.addToCart(btn);
        }.bind(this));
      }

      values() {
        return { to: this.fTo.value.trim(), from: this.fFrom.value.trim(), msg: this.fMsg.value.trim() };
      }

      render() {
        var v = this.values();
        var sample = this.dataset.sample || '';
        var ph = function (t) { return '<span class="okd__ph-text">' + esc(t) + '</span>'; };
        var name = v.to ? esc(v.to) : ph(this.dataset.hint || '');
        var body = v.msg ? esc(lowerFirst(v.msg)) : ph(lowerFirst(sample));
        this.querySelector('[data-okd-msg]').innerHTML = name + ', ' + body;
        this.querySelector('[data-okd-sign]').innerHTML =
          esc(this.dataset.sign || '') + ' ' + (v.from ? esc(v.from) : ph('Tu nombre'));
        this.note.classList.toggle('is-long', (v.to.length + (v.msg || sample).length) > 150);
        this.querySelector('[data-okd-count]').textContent = this.fMsg.value.length + '/' + this.dataset.max;
        var current = this.fMsg.value.trim();
        this.chips.forEach(function (c) { c.setAttribute('aria-pressed', String(c.textContent.trim() === current)); });
      }

      openCard() {
        var clone = this.note.cloneNode(true);
        clone.removeAttribute('data-okd-note');
        clone.setAttribute('aria-label', 'Cerrar vista ampliada');
        this.lightbox.querySelector('[data-okd-lightbox-card]').replaceChildren(clone);
        this.lightbox.classList.add('is-open');
        this.lightbox.querySelector('.okd-lightbox__close').focus();
      }

      closeCard() {
        this.lightbox.classList.remove('is-open');
        this.note.focus();
      }

      showToast(html, img, isError) {
        this.toast.querySelector('[data-okd-toast-text]').innerHTML = html;
        var im = this.toast.querySelector('[data-okd-toast-img]');
        if (img) im.src = img; else im.removeAttribute('src');
        this.toast.classList.toggle('is-error', !!isError);
        this.toast.classList.add('is-visible');
        clearTimeout(this._toastTimer);
        this._toastTimer = setTimeout(function () { this.toast.classList.remove('is-visible'); }.bind(this), 4500);
      }

      async addToCart(btn) {
        var v = this.values();
        var form = new FormData();
        form.append('id', btn.dataset.variant);
        form.append('quantity', '1');
        if (v.msg) {
          // Texto tal como se imprime en la tarjeta
          form.append('properties[Dedicatoria]', v.to ? v.to + ', ' + lowerFirst(v.msg) : v.msg);
          form.append('properties[Firma]', ((this.dataset.sign || '') + ' ' + v.from).trim());
        }
        var sectionIds = Array.prototype.map.call(document.querySelectorAll('cart-items-component'), function (el) {
          return el.dataset.sectionId;
        }).filter(Boolean);
        if (sectionIds.length) form.append('sections', sectionIds.join(','));

        // Avisamos al tema (Vessel / Horizon) igual que su propio botón, para que actualice el carrito
        var events = null, deferred = null;
        try { events = await import('@shopify/events'); } catch (e) { events = null; }
        var Ev = events && events.CartLinesUpdateEvent;
        if (Ev && Ev.createPromise) {
          deferred = Ev.createPromise();
          this.dispatchEvent(new Ev({
            action: 'add', context: 'product',
            lines: [{ merchandiseId: btn.dataset.variant, quantity: 1 }],
            promise: deferred.promise
          }));
        }

        btn.disabled = true;
        btn.classList.add('is-loading');
        var root = (this.dataset.root || '/').replace(/\/?$/, '/');
        try {
          var res = await fetch(this.dataset.cartAdd + '.js', {
            method: 'POST', body: form, headers: { Accept: 'application/json' }
          });
          var data = await res.json();
          if (data.status) throw new Error(data.description || data.message || 'No se pudo agregar');

          var cart = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
          if (deferred) {
            deferred.resolve({
              cart: Ev.createCartFromAjaxResponse ? Ev.createCartFromAjaxResponse(cart) : cart,
              detail: {
                items: cart.items, source: 'okd-dedicatoria', sourceId: this.dataset.sectionId,
                itemCount: 1, productId: btn.dataset.product, sections: data.sections, didError: false
              }
            });
          }
          var extra = v.msg ? (v.to ? ' · con dedicatoria para ' + esc(v.to) : ' · con dedicatoria') : '';
          this.showToast('Agregado al carrito<small>' + esc(btn.dataset.name) + extra + '</small>', btn.dataset.img);
        } catch (err) {
          if (deferred) deferred.reject(err);
          this.showToast('No pudimos agregarlo<small>' + esc(err.message) + '</small>', null, true);
        } finally {
          btn.disabled = false;
          btn.classList.remove('is-loading');
        }
      }
    }

    customElements.define('okd-dedicatoria', OkdDedicatoria);
  })();

  } catch(e) { console.error(e); }
})();
})();
